export { default as en } from './locales/en/common.json' with { type: 'json' };
export { default as es } from './locales/es/common.json' with { type: 'json' };

// Re-export types and activate i18next module augmentation for consumers
export type { SupportedLocale } from './i18n.types.js';
export { createServerTranslator } from './i18n.server.js';

// Locales with full translation coverage (UI + communications templates)
export const SUPPORTED_COMMS_LOCALES = ['en', 'es'] as const;
export type SupportedCommsLocale = (typeof SUPPORTED_COMMS_LOCALES)[number];

// Language codes supported for interview configuration
export { SUPPORTED_LANGUAGES, type SupportedLanguage } from '@kiku/config/constants';
